import React, { Component } from 'react';

export default class Tag extends Component {

	render() {
		return (
			<div>
				<div id="myCanvasContainer">
					<canvas width="500" height="500" id="myCanvas">
						<ul>
							<li> <a href="https://en.wikipedia.org/wiki/HTML">HTML 5</a></li>
							<li><a data-weight="25" href="https://en.wikipedia.org/wiki/Cascading_Style_Sheets">CSS</a></li>
							<li><a data-weight="25" href="https://en.wikipedia.org/wiki/JavaScript">JavaScript</a></li>
							<li><a data-weight="25" href="https://en.wikipedia.org/wiki/JavaScript">TypeScript</a></li>
							<li><a data-weight="24" href="https://en.wikipedia.org/wiki/Representational_state_transfer">REST</a></li>
							<li><a data-weight="14" href="https://en.wikipedia.org/wiki/JSON">JSON</a></li>
							<li><a data-weight="13" href="https://en.wikipedia.org/wiki/XML">XML</a></li>
							<li><a data-weight="27" href="https://en.wikipedia.org/wiki/AngularJS">Angular 2+</a></li>
							<li><a data-weight="26" href="https://en.wikipedia.org/wiki/WordPress">Wordpress</a></li>
							<li><a data-weight="21" href="https://en.wikipedia.org/wiki/Node.js">Node JS</a></li>
							<li><a data-weight="17" href="https://en.wikipedia.org/wiki/Git">Git</a></li>
							<li><a data-weight="17" href="/">_lodash</a></li>
							<li><a data-weight="23" href="https://en.wikipedia.org/wiki/Bootstrap_(front-end_framework)">Bootstrap</a></li>
							<li><a data-weight="15" href="https://en.wikipedia.org/wiki/Sass_(stylesheet_language)">SASS</a></li>
							<li><a data-weight="20" href="https://en.wikipedia.org/wiki/Responsive_web_design">RxJs</a></li>
							<li><a data-weight="19" href="https://en.wikipedia.org/wiki/JQuery">jQuery</a></li>
							<li><a data-weight="19" href="http://mongoosejs.com/">NoSQl</a></li>
							<li><a data-weight="19" href="https://karma-runner.github.io/1.0/index.html">Karma</a></li>
							<li><a data-weight="19" href="http://gulpjs.com/">Gulp</a></li>
							<li><a data-weight="19" href="https://www.npmjs.com/">npm</a></li>
							<li><a data-weight="19" href="https://bower.io/">Bower</a></li>
							<li><a data-weight="19" href="https://en.wikipedia.org/wiki/BEM">BEM</a></li>
						</ul>
					</canvas>
				</div>
			</div>
		);
	}

}